/**
 * Etat « actif » d'un lien de la barre laterale.
 *
 * Le NavLink de React Router ne compare que le chemin, et par prefixe : sur
 * /tickets/123, tous les liens /tickets?preset=… (filtres, traitants,
 * clients) passaient actifs ensemble. Ici :
 *  - un lien avec parametres (/tickets?preset=mes) n'est actif que si le
 *    chemin est exactement le meme ET que chacun de ses parametres a la meme
 *    valeur dans l'adresse courante (d'autres parametres peuvent s'y ajouter) ;
 *  - un lien sans parametre garde la regle du NavLink : chemin identique ou
 *    sous-chemin (/admin/clients reste actif sur /admin/clients/12).
 */
function normalize(path: string): string {
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function isNavItemActive(to: string, pathname: string, search: string): boolean {
  const q = to.indexOf('?');
  const toPath = normalize(q === -1 ? to : to.slice(0, q));
  const here = normalize(pathname);

  if (q === -1) {
    return here === toPath || (toPath !== '/' && here.startsWith(toPath + '/'));
  }

  if (here !== toPath) return false;
  const wanted = new URLSearchParams(to.slice(q + 1));
  const current = new URLSearchParams(search);
  for (const [k, v] of wanted) {
    if (current.get(k) !== v) return false;
  }
  return true;
}
